import { Form, Switch as AntSwitch, Row, Col, Button, Space, Typography, message } from 'antd';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import StickyFooter from 'common/components/StickyFooter';
import useConfig from 'common/hooks/useConfig';

import {
  ALLOW_ATTENDEES_TO_CHANGE_THEIR_RESPONSES,
  SHOW_UNMODERATED_TEXT_ANSWERS,
} from './constants';

const { Text } = Typography;

const Wrap = styled.div`
  margin: 0 auto 50px;
  padding-bottom: 86px;
`;

const Switch = styled(AntSwitch)`
  margin-left: 50px;
`;

const SwitchWrapper = styled(Col)`
  padding-bottom: 20px;
`;

const Container = styled(Space)`
  padding: 24px 58px;
`;

const useSettings = () => {
  const { set, isConfigEnabled, loading } = useConfig();

  const initialValues = useMemo(
    () => ({
      allowAttendees: isConfigEnabled(ALLOW_ATTENDEES_TO_CHANGE_THEIR_RESPONSES),
      showUnmoderatedText: isConfigEnabled(SHOW_UNMODERATED_TEXT_ANSWERS),
    }),
    [isConfigEnabled],
  );

  const onSave = async values => {
    try {
      await set([
        {
          keyId: ALLOW_ATTENDEES_TO_CHANGE_THEIR_RESPONSES,
          value: values.allowAttendees ? '1' : '0',
        },
        {
          keyId: SHOW_UNMODERATED_TEXT_ANSWERS,
          value: values.showUnmoderatedText ? '1' : '0',
        },
      ]);

      message.success(t`Successfully updated settings.`);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      message.error(t`Error updating settings.`);
    }
  };

  return { initialValues, onSave, isSaving: loading };
};

const Settings = () => {
  const { initialValues, onSave, isSaving } = useSettings();

  return (
    <Wrap>
      <Form colon={false} initialValues={initialValues} onFinish={onSave} requiredMark={false}>
        <Container>
          <Col>
            <Row>
              <SwitchWrapper>
                <Text>{t`Allow attendees to change their responses`}</Text>
              </SwitchWrapper>
            </Row>
            <Row>
              <Col>
                <Text>{t`Show unmoderated text answers from live results by default`}</Text>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <SwitchWrapper>
                <Form.Item noStyle name="allowAttendees" valuePropName="checked">
                  <Switch data-testid="allow-attendees" />
                </Form.Item>
              </SwitchWrapper>
            </Row>
            <Row>
              <Col>
                <Form.Item noStyle name="showUnmoderatedText" valuePropName="checked">
                  <Switch data-testid="show-unmoderated-text" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Container>
        <StickyFooter>
          <Button type="primary" htmlType="submit" loading={isSaving}>{t`Save Settings`}</Button>
        </StickyFooter>
      </Form>
    </Wrap>
  );
};

export default Settings;
